export default __webpack_public_path__ + "59c20f096ca8c185fc79bfd153b06cbb.png";